import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MapInformationService } from 'src/app/services/map-information.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { ProjectService } from 'src/app/services/project.service';
import { PartsService } from 'src/app/services/parts.service';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vendor-alps-popup',
  templateUrl: './vendor-alps-popup.component.html',
  styleUrls: ['./vendor-alps-popup.component.scss']
})

export class VendorAlpsPopupComponent implements OnInit {
  @Input() vendorId: any;
  @Input() vendorToken: any;
  @Input() vendorMasterId: any;

  //Popups
  @Input() popupAPL: boolean;
  @Input() importingParts: boolean;
  @Output() reload = new EventEmitter<any>();
  @Output() closePopups = new EventEmitter<any>();

  //Popup Search
  @Input() popupPartsSearch: boolean;
  @Input() searchProductData: any;
  @Input() fromPart: boolean = false;
  @Input() insertMaster: boolean = false;

  settings = { dateFormat: '', moneyFormat: '' }

  //NewEditVendor
  popupNewItemVen: boolean = false;
  newVendor: FormGroup = new FormGroup({
    id: new FormControl('', []),
    partid: new FormControl('', []),
    vendorid: new FormControl('', []),
    partnumber: new FormControl('', []),
    default: new FormControl('', []),
    lastcost: new FormControl('', []),
    listprice: new FormControl('', []),
    uomid: new FormControl('', []),
  });
  vendorList: any = [];
  vendorPartsUom: any = [];
  popupConfirmVendorDefault: boolean = false;
  selectedEditData: any = {};

  //DeleteVendor

  // popupAPL = false;
  popupProductType = false;
  popupParts = false;
  cancelButton: any;
  cancelButtonParts: any;
  cancelButtonProductTypes: any;

  //Import Vendor
  showSelectProduct: boolean = false;
  categories: any = [];
  manufacturersCategory: any = [];
  manufacturersProducts: any = [];
  manufacturersProductType: any = [];
  products: any = [];
  productType: any = [];

  selectedCategory: any = {};
  selectedManufacturer: any;
  selectedProductType: any = {};
  selectedManufacturerCategory: any;

  search = { Name: '' }
  defaultProducts = [];
  defaultCategories = [];
  defaultProductTypes = [];

  disableSearchProduct: boolean = false;
  showCategorysSearchPart: boolean = false;
  searchedProduct: any = {};

  textAddCubePopup: any = 'Add to Cube';
  itemsSyncUp: any = [];

  closeAllPopups: any;

  constructor(
    public MapInformationService: MapInformationService,
    private ProjectService: ProjectService,
    private appconfig: AppConfigService,
    private translate: TranslateService,
    private partService: PartsService,
    private toast: ToastService,
    private datepipe: DatePipe,
    private router: Router,
  ) {
    this.settings.dateFormat = this.appconfig.dateFormat;
    this.settings.moneyFormat = this.appconfig.moneyFormat;

    // botones modales apl
    this.cancelButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.popupAPL = false;
        if(Object.keys(this.searchedProduct).length > 0){
          this.showCategorysSearchPart = true;
          this.searchedProduct = {};
        }else{
          this.closePopups.emit();
          this.popupPartsSearch = false;
          this.showCategorysSearchPart = false;
          this.searchedProduct = {};
        }
      },
    };

    this.cancelButtonParts = {
      text: this.translate.instant('btnBack'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupParts = false;
      },
    }

    this.cancelButtonProductTypes = {
      text: this.translate.instant('btnBack'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupProductType = false;
      },
    }

    this.closeAllPopups = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupProductType = false;
        this.popupAPL = false;
        this.popupParts = false;
        this.popupPartsSearch = false;
        this.closePopups.emit();
      },
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Cambios ', changes);
    console.log('Popup Parts ', this.popupPartsSearch);
    if (changes.popupAPL && changes.popupAPL.currentValue === true) {
      console.log('Popup APL1 ', this.popupAPL);
      this.mdAPL();
    } else if (changes.popupPartsSearch && changes.popupPartsSearch.currentValue === true) {
      console.log('Popup Parts Search ', this.popupPartsSearch);

      this.mdPartsNumber(changes.searchProductData ? changes.searchProductData.currentValue : this.searchProductData);
    }
  }

  // modal apl search category
  mdAPL(manufacturer = '') {
    // this.popupPartsSearch == false ? this.popupAPL = true : '';

    if(this.popupPartsSearch == false){
      this.popupPartsSearch = true; 
      this.showCategorysSearchPart = true;
      this.searchedProduct = {};
    }

    console.log('Manufacturer ', manufacturer);
    
    this.MapInformationService.GetCategories(manufacturer, this.vendorToken, this.vendorMasterId).subscribe((result: any) => {
      
      this.categories = result.Payload.sort((a, b) => {
        if (a.Name < b.Name) { return -1; }
        if (a.Name > b.Name) { return 1; }
        return 0;
      });
      this.defaultCategories = this.categories;
    })

    if (manufacturer == '') {
      this.MapInformationService.GetManufacturer('', '', this.vendorToken, this.vendorMasterId).subscribe((result: any) => {
        console.log('Manufactureer ', result);
        this.manufacturersCategory = result.Payload.sort((a, b) => {
          if (a.Name < b.Name) { return -1; }
          if (a.Name > b.Name) { return 1; }
          return 0;
        });
      })
    }
  }

  // modal apl search products
  mdParts(category, producttype = '', manufacturer = '') {
    this.selectedCategory = category;
    this.selectedManufacturer = manufacturer;
    this.selectedProductType = producttype;
    this.products = [];

    this.MapInformationService.GetByCategoryId(category.CategoryId, producttype, manufacturer, this.vendorToken).subscribe((result: any) => {
      // console.log('Resultado By ID ', result);
      this.products = result.Payload.sort((a, b) => {
        if (a.Name < b.Name) { return -1; }
        if (a.Name > b.Name) { return 1; }
        return 0;
      });
      this.defaultProducts = this.products;
    })

    this.MapInformationService.GetManufacturer(category.CategoryId, producttype, this.vendorToken, this.vendorMasterId).subscribe((result: any) => {
      console.log('Manufactureer ', result);
      this.manufacturersProducts = result.Payload.sort((a, b) => {
        if (a.Name < b.Name) { return -1; }
        if (a.Name > b.Name) { return 1; }
        return 0;
      });
    })


    this.popupParts = true;

    if (this.importingParts == false) {
      this.textAddCubePopup = this.translate.instant('ModuleVendorPartList.LinkCube');
    } else {
      this.textAddCubePopup = this.translate.instant('ModuleVendorPartList.AddCube');
    }
  }

  //modal product types categorys
  mdProductType(category, manufacturer = '') {
    this.selectedCategory = category;

    this.MapInformationService.GetproductType(category.CategoryId, manufacturer, this.vendorToken).subscribe((result: any) => {
      console.log('Product Type ', result);
      this.productType = result.Payload.sort((a, b) => {
        if (a.Name < b.Name) { return -1; }
        if (a.Name > b.Name) { return 1; }
        return 0;
      });

      this.defaultProductTypes = this.productType;

      this.popupProductType = true;
    })

    if (manufacturer === '') {
      this.MapInformationService.GetManufacturer(category.CategoryId, '', this.vendorToken, this.vendorMasterId).subscribe((result: any) => {
        this.manufacturersProductType = result.Payload.sort((a, b) => {
          if (a.Name < b.Name) { return -1; }
          if (a.Name > b.Name) { return 1; }
          return 0;
        });
      })
    }
  }

  partnumber = '';
  timeoutTarget;
  searchByPartNumber(data) {
    console.log("🚀 ~ VendorAlpsPopupComponent ~ searchByPartNumber ~ data:", data)

    clearTimeout(this.timeoutTarget); // Limpiar el temporizador existente


      const inputValue = data.event.target.value;
  
      this.timeoutTarget = setTimeout(() => {
        console.log("Esperaste 2 segundos");
        console.log(inputValue);
        this.partnumber = inputValue;
        console.log("🚀 Partnumber actualizado:", this.partnumber);
  
        let searchBy = {
          NUMBER: inputValue
        }

        this.mdPartsNumber(searchBy)

      }, 2000);

  }

  mdPartsNumber(data) {
    console.log('DATA ', data);
    this.searchedProduct = { ...this.searchedProduct, ...data, Number: data.NUMBER }

    this.MapInformationService.GetProductByNumber(data.NUMBER, this.vendorMasterId, this.vendorToken).subscribe((result: any) => {
      console.log('Products ', result);
      this.popupPartsSearch = true;

      if (Array.isArray(result.Payload)) {
        this.products = result.Payload.sort((a, b) => {
          if (a.Name < b.Name) { return -1; }
          if (a.Name > b.Name) { return 1; }
          return 0;
        });
      } else {
        this.products = result.Payload == null ? [result] : [result.Payload];
      }

      this.mdAPL();
    })
  }

  searchCategory(event) {
    let newEvent = event.event.target.value;
    console.log('New Evento Category ', newEvent);
    if (newEvent !== null && newEvent !== '') {
      let filter = this.defaultCategories.filter(item => item.Name.toLowerCase().indexOf(newEvent.toLowerCase()) >= 0);
      console.log('Filtrados ', filter);
      this.categories = filter;
    } else {
      console.log('No Event ', newEvent);
      this.categories = this.defaultCategories;
    }
  }

  searchProductType(event) {
    let newEvent = event.event.target.value;
    console.log('New Evento Category ', newEvent);
    if (newEvent !== null && newEvent !== '') {
      let filter = this.defaultProductTypes.filter(item => item.Name.toLowerCase().indexOf(newEvent.toLowerCase()) >= 0);
      console.log('Filtrados ', filter);
      this.productType = filter;
    } else {
      console.log('No Event ', newEvent);
      this.productType = this.defaultProductTypes;
    }
  }

  searchProduct(evento, search?) {
    console.log(evento);
    let event = evento ? evento.event.target.value : '';
    console.log('event ', event);
    console.log("BUSCANDO PRODUCTOS ");
    if (event !== undefined) {
      if (event !== null && event !== '') {
        if (search) {
          console.log('Search ', search, ' /event: ', event);
          this.mdPartsNumber({ NUMBER: event });
          this.showCategorysSearchPart = false;
        } else {
          let filter = this.defaultProducts.filter(item => item.Name.toLowerCase().indexOf(event.toLowerCase()) >= 0);
          console.log('Filtrados ', filter);
          this.products = filter;
        }
      } else {
        this.products = this.defaultProducts;
        console.log('Products Search ', this.products);

        if (search) {
          this.showCategorysSearchPart = true;
          // this.textAddCubePopup = 'Link to Cube';
          console.log('Entre Acá ', this.showCategorysSearchPart);

          this.MapInformationService.GetManufacturer('', '', this.vendorToken, this.vendorMasterId).subscribe((result: any) => {
            console.log('Manufactureer ', result);
            this.manufacturersProducts = result.Payload.sort((a, b) => {
              if (a.Name < b.Name) { return -1; }
              if (a.Name > b.Name) { return 1; }
              return 0;
            });
          })
        }
      }
    }
  }

  saveVendor(defaultVendor) {
    let form = this.newVendor.value;
    form.default = defaultVendor;
    form.method = 'InsertUpdate_VendorParts';
    console.log('Actualizando al final ', form)
    this.partService.InsertUpdate(form).subscribe(result => {
      this.popupConfirmVendorDefault = false;
      this.toast.success(this.translate.instant('msgVendInfoUpdSucc'));
      this.popupNewItemVen = false;
      this.reload.emit();
    })
  }

  onValueChangedSearchProduct(event) {
    console.log('OnValueChanged ', event);
  }

  importPart(product) {
    console.log('Producto a Importar ', product);
    console.log("PARTS import ", this.importingParts);
    console.log(this.showCategorysSearchPart, ' / ', this.searchedProduct);
    if ((this.showCategorysSearchPart == true || JSON.stringify(this.searchedProduct) !== '{}') && !this.importingParts) {
      
        console.log('Show Category Search ', this.searchedProduct);
      let number = product.Name;
      console.log('Name ', number)

      this.newVendor = new FormGroup({
        id: new FormControl(this.searchedProduct.ID, []),
        partid: new FormControl(this.searchedProduct.PARTID, []),
        vendorid: new FormControl(this.vendorId, []),
        partnumber: new FormControl(number, []),
        default: new FormControl(this.searchedProduct.DEFAULTFLAG, []),
        lastcost: new FormControl(this.searchedProduct.LASTCOST, []),
        listprice: new FormControl(this.searchedProduct.LISTPRICE, []),
        uomid: new FormControl(this.searchedProduct.UOMID, []),
      });

      this.searchedProduct.NUMBER = number;

      this.saveVendor(this.searchedProduct.DEFAULTFLAG == true ? 1 : 0);
      setTimeout(() => {
        this.syncWithVendor(this.searchedProduct, '')
        setTimeout(() => {
          this.popupPartsSearch = false;
          this.popupParts = false;
          this.showCategorysSearchPart = false;
          this.popupProductType = false;

          this.searchedProduct = {};
        }, 300);
      }, 500);
    } else {
      console.log('Importing New Part ', this.vendorId);
      let vendorid = this.vendorId;
      if (this.fromPart) {
        this.partService.InsertUpdate({ method: 'Get_Master_VendorsAlps' }).subscribe(result => {
          console.log("VENDOR ALPS?? ", result);
          if (result[0].Column1 == 1) {
            this.toast.warning("There are more than one vendors associated");
          } else {
            vendorid = result[0].ID;
            this.insertPartWithVendorId(product, vendorid)
          }
        });
      } else {
        this.insertPartWithVendorId(product, vendorid);
      }
    }
  }

  insertPartWithVendorId(product, vendorid) {
    console.log("VENDORID?? ", vendorid)

    let insert = {}

    if(this.insertMaster) {
      insert = {
        method: 'InsertUpdate_AcctPartsMasterCE',
        partnumber: product.Name,
        partdescription: product.Description,
        price: product.ListPrice,
        vendorlistid: vendorid,
        id: 0
      }
    } else {
      insert = {
        method: 'InsertUpdate_AcctPartsCEAlps',
        partnumber: product.Name,
        partdescription: product.Description,
        price: product.ListPrice,
        vendorlistid: vendorid,
        id: 0
      }
    }

    console.log("🚀 ~ file: vendor-alps-popup.component.ts:422 ~ insertPartWithVendorId ~ insert:", insert)
    this.partService.InsertUpdate(insert).subscribe(result => {

      console.log('Parte Importada ', result);
      console.log("FROM PART?? ", this.fromPart);

      if (result[0].ResultID == -2) {
        this.popupAPL = false;
        this.popupParts = false;
        this.popupProductType = false;
        this.popupPartsSearch = false;

        let filter = [
          "NUM",
          "contains",
          product.Name
        ];

        this.toast.warning(this.translate.instant('msgDuplicatedImportedPart'));

        // this.reload.emit(filter);
        this.reload.emit();
        this.closePopups.emit();
        return;
      }

      let data = {
        id: 0,
        partid: result[0].ResultID,
        vendorid: vendorid,
        partnumber: product.Name,
        partdescription: product.Description,
        default: 1,
        lastcost: 0,
        employeeid: "",
        listprice: product.ListPrice,
        uomid: null,
        method: "InsertUpdate_VendorParts"
      }
      
      this.partService.InsertUpdate(data).subscribe(resultDefault => {
        console.log('Agregando Vendor Default ', data)
        console.log(resultDefault)
        this.popupAPL = false;
        this.popupParts = false;
        this.popupProductType = false;
        this.popupPartsSearch = false;
        this.reload.emit(data);
        this.closePopups.emit();

        let syncVendor = {
          NUMBER: product.Name,
          ID: resultDefault[0].ResutlID
        }
        if (!this.fromPart) {
          this.syncWithVendor(syncVendor, '')
        }

        this.toast.success(this.translate.instant('msgImportedPartSucc'));
      })
    })
  }

  syncWithVendor(data, update) {
    console.log(this.vendorMasterId, this.vendorToken)
    try {
      this.MapInformationService.syncVendorPart2(data.NUMBER, data.ID, 1, this.vendorMasterId, this.vendorToken)
        .subscribe(
          (data: any) => {
            console.log('Sincronizado ', data);
            this.closePopups.emit();
            if (data.masterid == "" || data.masterid == 0) {
              console.log('No se encontró la parte ')
              this.toast.warning(this.translate.instant('msgPartNotFoundWarn'));
              // this.getVendorPartList();
              this.reload.emit();
            } else {
              console.log('Se encontró la parte ')
              this.toast.success(this.translate.instant('msgUpdatSucc'))
              // this.getVendorPartList();
              this.reload.emit();
            }
          },
          (error => {
            console.log('Error ', error);
            this.closePopups.emit();
            this.toast.warning(this.translate.instant('msgUnableGetDetailsWarn'));
          })
        )
    } catch (e) {
      console.log('Error ', e);
      this.closePopups.emit();
    }
  }
}
